import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('packstation-loader', () => import(/* webpackMode: "lazy" */'./packstation-loader'));
